import { render, staticRenderFns } from "./yyu8SourceListDialog.vue?vue&type=template&id=0670e5a4&scoped=true&"
import script from "./yyu8SourceListDialog.vue?vue&type=script&lang=js&"
export * from "./yyu8SourceListDialog.vue?vue&type=script&lang=js&"
import style0 from "./yyu8SourceListDialog.vue?vue&type=style&index=0&id=0670e5a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0670e5a4",
  null
  
)

export default component.exports